module.exports = __webpack_public_path__ + "img/12.7.Chla.7ff8b785.png";